import { Pipe, PipeTransform } from '@angular/core';

const QUALIFIER_MAP: Record<string, string> = {
  TE: 'Telephone',
  EM: 'Email',
  FX: 'Fax',
};

@Pipe({
  name: 'contactQualifier',
})
export class ContactQualifierPipe implements PipeTransform {
  public transform(value: string | null | undefined): string | null | undefined {
    if (!value) {
      return value;
    }
    const upper = value.toUpperCase();
    return QUALIFIER_MAP[upper] ?? value;
  }
}
